module.exports = __webpack_public_path__ + "static/media/2.f21e58d0.jpg";